import { useMutation, useQueryClient } from '@tanstack/react-query';
import { backgroundJobsApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useRequeueBackgroundJob() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => backgroundJobsApiClient.requeueJob(id),
    meta: {
      successMessage: 'Job requeued',
      errorContext: 'requeue background job',
    },
    onSettled: () => invalidateFor('backgroundJobs.requeue', qc),
  });
}

export function useDeleteBackgroundJob() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => backgroundJobsApiClient.deleteJob(id),
    meta: {
      successMessage: 'Job deleted',
      errorContext: 'delete background job',
    },
    onSettled: () => invalidateFor('backgroundJobs.delete', qc),
  });
}

export function useTriggerRecurringBackgroundJob() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => backgroundJobsApiClient.triggerRecurringJob(id),
    meta: {
      successMessage: 'Recurring job triggered',
      errorContext: 'trigger recurring background job',
    },
    onSettled: () => invalidateFor('backgroundJobs.trigger', qc),
  });
}
